import { UserProviderInfoModel } from "../../data/entities";
import { UserProviderCalendarODataRepo, UserProviderCalendarRepo } from "../../data/repo";
import { BaseEntityService } from "../BaseEntityService"

export class UserProviderCalendarService extends BaseEntityService<UserProviderInfoModel, UserProviderCalendarRepo, UserProviderCalendarODataRepo> {
  constructor(){
    super(new UserProviderCalendarRepo(), new UserProviderCalendarODataRepo());
  }
  async getUserProvidersByUserIdAsync(userId?: string): Promise<UserProviderInfoModel[]> {
    return await this.repo.getUserProvidersByUserIdAsync(userId);
  }
}

export default UserProviderCalendarService;
